// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 35) return "static/chunks/35.aa19117b0e2ed2a5.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"700":"b2def4d928d28b2a","703":"aa15043f43af529a"}[chunkId] + ".js";
};